import * as React from "react";

const RegionDetails = React.lazy(
  () =>
    import(/* webpackChunkName: "region-details" */ "./RegionDetails")
);

export const LazyRegionDetails = () => (
  <React.Suspense>
    <RegionDetails />
  </React.Suspense>
);
